module.exports = "/_next/static/images/a76da37625fb21a3957ceb3e4d1a8d2f-woman-with-iphone@0.5x.jpg";